import { useNavigate } from "react-router-dom";

function checkToken(navigator) {
  var hour = 1;
  var settedTime = localStorage.getItem("tokenSetTime");
  const date = new Date();
  const time = date.getTime();
  if (time > +settedTime + +(hour * 60 * 60 * 1000) || time < settedTime) {
    localStorage.clear();
    navigator("/login");
  }
}
export default checkToken;
